const EMAIL_VALIDATION_REGEX = /[a-z\-.+_0-9]+@(([a-z\-0-9]+\.)+[a-z]{2,})$/;

export default function validateEmail(email) {
    return EMAIL_VALIDATION_REGEX.test(email);
}
